function CrossIcon({ fill, className = "", ariaLabel = "Cross Icon" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      focusable="false"
      aria-label={ariaLabel}
    >
      <title>{ariaLabel}</title>
      <path
        d="M6 6L18 18M6 18L18 6"
        stroke={fill}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CrossIcon;
